import BaseService from '@root/core/class/BaseService';
import {
  bodyCommentWarehouse,
  bodyCompleteInbound
} from '@root/state/reducers/inboundReducer/inboundReducers';
import { InboundPagination } from '../Interface';

class inboundService extends BaseService {
  // get inbound
  public getListInbound = () => {
    return this.get('/imports');
  };
  // get inbound pagination
  public getPagination = (
    page: number,
    sort?: boolean,
    fromDt?: string,
    toDt?: string,
    searchBy?: string,
    input?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    let url = `/imports?page=${page}&limit=10${
      (!!searchBy && !!inputUse
        ? `&searchBy=${searchBy}&search=${inputUse}`
        : '') +
      (!!fromDt ? `&fromDt=${fromDt}` : '') +
      (!!toDt ? `&toDt=${toDt}` : '') +
      (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    }`;
    return this.get(url);
  };
  // get inbound detail
  public getDetailInbound = (id: string) => {
    return this.get(`/imports/${id}`);
  };

  // download inbound
  public postDownloadExcel = () => {
    return this.post(
      '/imports/export',
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public postDownloadExcelId = (body: Record<string, any>) => {
    return this.post('/imports/export', body, {
      responseType: 'blob'
    });
  };

  public exportExcel = ({
    sort,
    fromDt,
    toDt,
    searchBy,
    valueSearch
  }: InboundPagination) => {
    let url = `/imports/export`;
    url =
      (!!searchBy && !!valueSearch) || !!sort || !!fromDt || !!toDt
        ? url + '?'
        : url;

    url +=
      (!!searchBy && !!valueSearch
        ? `&searchBy=${searchBy}&search=${valueSearch}`
        : '') +
      (!!fromDt ? `&fromDt=${fromDt}` : '') +
      (!!toDt ? `&toDt=${toDt}` : '') +
      (sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC');
    let urlUse = url.replace('?&', '?');
    return this.post(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  // approve inbound
  public postApproveInbound = (
    importId: string,
    body: bodyCommentWarehouse
  ) => {
    return this.post(`/imports/${importId}/approve`, body);
  };

  // complete inbound
  public postCompleteInbound = (
    importId: string,
    body: bodyCompleteInbound
  ) => {
    return this.post(`/imports/${importId}/complete`, body);
  };

  public updateInventories = (inventories: Array<any>, commentId: number) => {
    return this.post(`/sellers/updateMultiple`, {
      inventories: inventories,
      commentId: commentId
    });
  }
}

export default new inboundService('/api/v1/warehouse', true);
